<div class="ion-page">
  <div class="custom-loading-overlay">
    <div class="loader"></div>
  </div>
</div>
